import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/shared/Logo";
import { Button } from "../components/shared/Button";
import { Footer } from "../components/shared/Footer";
import { getSurveyCount } from "../lib/api";

const THRESHOLD = 500;

export default function Results() {
    const navigate = useNavigate();
    const [count, setCount] = useState(null);

    useEffect(() => {
        let alive = true;
        getSurveyCount().then((n) => {
            if (alive) setCount(n);
        });
        return () => {
            alive = false;
        };
    }, []);

    const pct =
        count === null ? 0 : Math.min(100, Math.round((count / THRESHOLD) * 100));

    return (
        <div className="relative min-h-screen klareet-grain klareet-glow">
            <header className="relative z-10 px-5 md:px-12 pt-6 pb-2 flex items-center justify-between">
                <Logo className="h-14 md:h-16 w-auto" />
                <div className="text-[11px] uppercase tracking-[0.22em] font-mono text-klareet-MUT">
                    Aggregate results
                </div>
            </header>

            <main className="relative z-10 px-5 md:px-12 pt-12 pb-24 max-w-3xl mx-auto">
                <div className="rounded-3xl border border-klareet-bor bg-klareet-card p-8 md:p-12">
                    <div className="text-[11px] uppercase tracking-[0.22em] font-mono text-klareet-T2">
                        Coming soon
                    </div>
                    <h1 className="mt-4 text-3xl md:text-4xl font-semibold tracking-tight text-klareet-TEXT leading-tight">
                        Aggregate results publish at 500 responses.
                    </h1>
                    <p className="mt-4 text-klareet-MUT leading-relaxed max-w-prose">
                        We want the sample to be honest before it's shared.
                        Once we cross 500 responses, every person who filled
                        this out will see the aggregate: personas, pains,
                        prices, waitlist intent. The real market picture.
                    </p>

                    <div className="mt-8">
                        <div className="flex items-center justify-between text-sm text-klareet-MUT mb-2">
                            <span>
                                Current: <span
                                    className="font-mono text-klareet-TEXT"
                                    data-testid="results-count"
                                >
                                    {count ?? "…"}
                                </span>
                            </span>
                            <span className="font-mono">
                                Target: {THRESHOLD}
                            </span>
                        </div>
                        <div className="h-3 rounded-full bg-klareet-BOR overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-klareet-T to-klareet-T2 rounded-full transition-[width] duration-700 ease-[cubic-bezier(.2,.8,.2,1)]"
                                style={{ width: `${pct}%` }}
                            />
                        </div>
                        <div className="mt-2 text-xs font-mono text-klareet-DIM">
                            {pct}% there
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex flex-wrap gap-3">
                    <Button variant="outline" onClick={() => navigate("/")}>
                        <ArrowLeft size={16} />
                        Back to landing
                    </Button>
                </div>
            </main>

            <Footer />
        </div>
    );
}
